import { MenuItemDataRef } from './MenuContext';
import { Focus } from './utils/getIndex';

// Action type IDs (allows action type names to be minified)
export const CLOSE_MENU = 0;
export const OPEN_MENU = 1;
export const GO_TO_ITEM = 2;
export const SEARCH = 3;
export const CLEAR_SEARCH = 4;
export const REGISTER_ITEM = 5;
export const UNREGISTER_ITEM = 6;

export type Action =
  | { type: typeof CLOSE_MENU }
  | { type: typeof OPEN_MENU }
  | { type: typeof GO_TO_ITEM; focus: Focus.SPECIFIC; id: string }
  | {
      type: typeof GO_TO_ITEM;
      focus: Exclude<Focus, Focus.SPECIFIC>;
    }
  | { type: typeof SEARCH; value: string }
  | { type: typeof CLEAR_SEARCH }
  | {
      type: typeof REGISTER_ITEM;
      id: string;
      dataRef: MenuItemDataRef;
    }
  | { type: typeof UNREGISTER_ITEM; id: string };
